export const SHIPPING_PROMOTIONS = {
    CREATE_NEW_PROMOTION: "create-new-promotion",
    DISPLAY_NAME: "display-name",
    ACTIVE_TOGGLE: "active-toggle",
    DESCRIPTION: "description",
    SPLIT_RULE: "split-rule",
    SPLIT_BEFORE: "split-before",
    SPLIT_AFTER: "split-after",
    BRAND_USER_ONLY: "brand-user-only",
    ADD_RULE: "add-rule",
    RULE_TYPE: "rule-type",
    TIME: "time",
    AMOUNT: "amount",
    QUANTITY: "quantity",
    FIELD: "field",
    SELECT_CARRIER: "select-carrier",
    START_DATE: "start-date",
    END_DATE: "end-date",
    CLEAR_ENDDATE_BTN: "clear-enddate",
    AT_LEAST: "at-least",
    AT_MOST: "at-most",
    LOOKUP_FIELD: "lookup-field",
    LOOKUP_FIELD_VALUE: "required-value",
    DELETE_PROMOTION_RULE: "delete-promotion-rule",
    PROMOTION_DEFINITION: "promotion-definition",
    PROMOTION_TYPE: "promotion-type",
    PRICE_OPTION: "price-option",
    PERCENTAGE_OPTION: "percentage-option",
    SUBSTITUTE_OPTION: "substitute-option",
    SET_PRICE: "set-price",
    SET_CURRENCY: "set-currency",
    APPLY_TO_SERVICE: "apply-to-service",
    REPLACEMENT_SERVICE: "replacement-service",
    INITIAL_OFFER_SERVICE: "initial-offer-service",
    SAVE: "save",
    BACK: "back",
    DELETE_PROMOTION: "delete-promotion",
    DIALOG_DELETE: "dialog-delete",
    DIALOG_CANCEL: "dialog-cancel",
    RULE_ROW: "rule-row",
};
